<template>
	<div class="flex-wrapper pd-vertical">
		<div class="flex-grow">
			{{ $t(labelKey) }}
		</div>
		<Button size="small" @click="onSelectAll">
			{{ $t(selectAllLabelKey) }}
		</Button>
	</div>
	<Select
		class="width-100"
		v-model:value="mountpointsSelected"
		mode="multiple"
		:allowClear="true"
		:options="mountpointsOptions"
		:placeholder="$t(placeholderKey)"
		@change="onUpdate"
	/>
</template>

<script>
import { computed, toRef, watch } from 'vue';
import { useVModel } from '@vueuse/core';

import { Button, Select } from 'ant-design-vue';

import { useBaseStationsStore } from '@/stores/baseStations';

export default {
	components: { Button, Select },
	props: {
		modelValue: {
			type: Array,
			required: true,
		},
		onUpdate: {
			type: Function,
			required: false,
			default: () => {},
		},
		labelKey: {
			type: String,
			default: 'controls.baseStationSelect.label',
		},
		selectAllLabelKey: {
			type: String,
			default: 'controls.baseStationSelect.selectAllLabel',
		},
		placeholderKey: {
			type: String,
			default: 'controls.baseStationSelect.placeholder',
		},
		subNetworkFilter: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const baseStationsStore = useBaseStationsStore();
		const subNetworksFilterRef = toRef(props, 'subNetworkFilter');
		const mountpointsSelected = useVModel(props, 'modelValue', emit);
		const mountpointsOptions = computed(
			() => subNetworksFilterRef.value ? baseStationsStore.mountpointsSelectCurrentSubNetworkOptions : baseStationsStore.mountpointsSelectOptions
		);
		watch(() => mountpointsOptions.value, options => {
			const optionsMap = new Set(options.map(option => option.value));
			const filteredMountpoints = mountpointsSelected.value.filter(mountpoint => optionsMap.has(mountpoint));
			if (filteredMountpoints.length !== mountpointsSelected.value.length) {
				mountpointsSelected.value = filteredMountpoints;
				props.onUpdate();
			}
		}, { immediate: true });

		const onSelectAll = () => {
			mountpointsSelected.value = mountpointsOptions.value.map(item => item.value);
			props.onUpdate();
		};
		return {
			mountpointsOptions,
			mountpointsSelected,
			onSelectAll,
		};
	},
}
</script>
